import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import DialogActions from '@mui/material/DialogActions';
import { Button, styled } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

const StyTextField = styled(TextField, {
    name: 'StyTextField',
})(() => ({
    marginLeft: '1rem',
    maxWidth: '50%',
}));

export const CreateDraftOperationName: React.FC<{
    closeModal: () => void;
    setStep: DispatchState<number>;
    name: string;
    setName: DispatchState<string>;
}> = ({ closeModal, setStep, name, setName }) => {
    const { t } = useTranslation();
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();
    return (
        <>
            <DialogTitle sx={{ fontSize: '18px', fontWeight: '600' }}>
                {t('createDraftOperation.chooseNameHeaderTitle', {
                    context: sourceTable,
                })}
            </DialogTitle>
            <DialogContent>
                {t('createDraftOperation.chooseNameHeaderDescription', {
                    context: sourceTable,
                })}
            </DialogContent>
            <DialogTitle sx={{ fontSize: '18px', fontWeight: '400' }}>
                {t('createDraftOperation.chooseNameTitle', {
                    context: sourceTable,
                })}
            </DialogTitle>
            <DialogContent sx={{ mb: 1 }}>
                {t('createDraftOperation.chooseNameDescription')}
            </DialogContent>
            <StyTextField
                value={name}
                onChange={(event) => setName(event.target.value)}
                variant="outlined"
            />
            <DialogActions>
                <Button onClick={closeModal}>{t('common.close')}</Button>
                <Button disabled={!name} onClick={() => setStep(2)}>
                    {t('common.next')}
                </Button>
            </DialogActions>
        </>
    );
};
